import "./pwa"; // catch the install prompt early (it fires once, soon after load)
import { render } from "preact";
import { useEffect, useState } from "preact/hooks";
import { api, getSession, onSession, type Session } from "./api";
import { installServerBase, isNative } from "./platform";
import * as S from "./state";
import { Login, ProfileSetup } from "./ui/Login";
import { Main } from "./ui/Main";
import { applyTheme } from "./ui/Shortcuts";
import { applyAppearance } from "./ui/Appearance";
import "./styles.css";

function Root() {
  const [session, setSession] = useState<Session | null>(getSession());
  useEffect(
    () =>
      onSession((s) => {
        S.addingAccount.value = false;
        setSession(s);
      }),
    [],
  );
  if (!session || S.addingAccount.value) return <Login onCancel={session ? () => (S.addingAccount.value = false) : undefined} />;
  // New accounts pick a name first, like WhatsApp's "Profile info" step.
  if (!session.user.name) return <ProfileSetup />;
  return <Main key={session.session_id} session={session} />;
}

installServerBase(); // native app: relative URLs -> the server
applyTheme(); // saved light / dark / system choice
applyAppearance(); // chat backgrounds and bubble colours
void api.config().then((c) => (S.mediaBase.value = c.media_base ?? ""), () => {});
render(<Root />, document.getElementById("app")!);
if (isNative) void import("./native").then((n) => n.initNative());

// Offline shell + media/tile cache (production web builds; the app bundles its own).
if ("serviceWorker" in navigator && import.meta.env.PROD && !isNative) {
  window.addEventListener("load", () => void navigator.serviceWorker.register("/sw.js").catch((e) => console.warn("service worker", e)));
}
